import "./application.css"

document.addEventListener("DOMContentLoaded", () => {
  addSiteMenuToggleListener();
  addMobileSectionMenuListener();
  observeSectionVisibility();
  addThemeSwitcherListener();
  addTabSwitcherListener();
  applyBrowserThemePreference();
  replaceFlagEmojis();
});

function replaceFlagEmojis(root = document.body) {
  // Updated Regex:
  // 1. Matches Regional Indicator pairs (standard flags)
  // 2. Matches the Black Flag + Tag sequences (England, Scotland, Wales)
  const flagRegex = /([\u{1F1E6}-\u{1F1FF}]{2}|(?:\u{1F3F4}[\u{E0061}-\u{E007F}]+))/gu;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodesToProcess = [];

  while (walker.nextNode()) {
    if (flagRegex.test(walker.currentNode.textContent)) {
      nodesToProcess.push(walker.currentNode);
    }
    flagRegex.lastIndex = 0;
  }

  nodesToProcess.forEach(textNode => {
    const fragment = document.createDocumentFragment();
    const text = textNode.textContent;
    let lastIndex = 0;
    let match;

    flagRegex.lastIndex = 0;
    while ((match = flagRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
      }

      const emoji = match[0];
      let countryCode = "";

      if (emoji.startsWith("🏴")) {
        // Handle Subdivision Flags (England, etc.)
        // Converts the tags to a string like 'gbeng'
        countryCode = [...emoji]
          .map(char => {
            const cp = char.codePointAt(0);
            return (cp >= 0xE0061 && cp <= 0xE007A)
              ? String.fromCodePoint(cp - 0xE0061 + 97)
              : "";
          })
          .join("");

        // Map 'gbeng' to 'gb-eng' for the flag-icons library
        if (countryCode === "gbeng") countryCode = "gb-eng";
        if (countryCode === "gbsct") countryCode = "gb-sct";
        if (countryCode === "gbwls") countryCode = "gb-wls";

      } else {
        // Handle Standard 2-letter flags
        countryCode = [...emoji]
          .map(cp => String.fromCharCode(cp.codePointAt(0) - 0x1F1E6 + 97))
          .join("");
      }

      const span = document.createElement("span");
      span.className = `fi fi-${countryCode} mx-1`;
      fragment.appendChild(span);

      lastIndex = match.index + emoji.length;
    }

    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    if (textNode.parentNode) {
      textNode.parentNode.replaceChild(fragment, textNode);
    }
  });
}

function addSiteMenuToggleListener() {
  const siteHeaderMobileMenu = document.querySelector(".site-header-mobile-menu");
  const siteHeaderMobileMenuToggle = document.querySelector(".site-header-mobile-menu-toggle");
  const siteHeaderTabletMenu = document.querySelector(".site-header-tablet-menu");
  const siteHeaderTabletMenuToggle = document.querySelector(".site-header-tablet-menu-toggle");

  siteHeaderMobileMenuToggle.addEventListener("click", () => {
    siteHeaderMobileMenu.classList.toggle("open");
  });

  siteHeaderTabletMenuToggle.addEventListener("click", () => {
    siteHeaderTabletMenu.classList.toggle("open");
  });
}

function addMobileSectionMenuListener() {
  document.querySelectorAll("#mobile-section-menu button").forEach(button => {
    button.addEventListener("click", (event) => {
      const targetSection = event.target.dataset.targetSection;
      const section = document.getElementById(targetSection);
      if (section) {
        const rect = section.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollTo = rect.top + scrollTop - 80;
        window.scrollTo({ top: scrollTo, behavior: "smooth" });
      }
    });
  });
}

function observeSectionVisibility() {
  const buttons = document.querySelectorAll("#mobile-section-menu button");
  const sectionToButton = new Map();
  const intersectingSections = new Set();

  buttons.forEach(button => {
    const targetSection = button.dataset.targetSection;
    const section = document.getElementById(targetSection);
    if (section) {
      sectionToButton.set(section, button);
    }
  });

  function updateActiveButton() {
    let lowestSection = null;
    let lowestTop = -Infinity;

    intersectingSections.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.top > lowestTop) {
        lowestTop = rect.top;
        lowestSection = section;
      }
    });

    sectionToButton.forEach((button, section) => {
      button.classList.toggle("active", section === lowestSection);
    });
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        intersectingSections.add(entry.target);
      } else {
        intersectingSections.delete(entry.target);
      }
    });
    updateActiveButton();
  }, { threshold: 0.02 });

  sectionToButton.forEach((button, section) => {
    observer.observe(section);
  });
}

function setThemeCookie(theme) {
  document.cookie = `theme=${theme}; path=/; max-age=31536000; SameSite=Lax`;
}

function getThemeCookie() {
  const match = document.cookie.match(/(?:^|; )theme=([^;]*)/);
  return match ? match[1] : null;
}

function applyBrowserThemePreference() {
  if (getThemeCookie()) return;

  if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
    document.body.dataset.theme = "dark";
  }
}

function addThemeSwitcherListener() {
  const lightThemeButtons = document.querySelectorAll(".light-theme-button");
  const darkThemeButtons = document.querySelectorAll(".dark-theme-button");

  lightThemeButtons.forEach(button => {
    button.addEventListener("click", () => {
      document.body.dataset.theme = "";
      setThemeCookie("light");
    });
  });

  darkThemeButtons.forEach(button => {
    button.addEventListener("click", () => {
      document.body.dataset.theme = "dark";
      setThemeCookie("dark");
    });
  });
}

function addTabSwitcherListener(){
  document.querySelectorAll(".mobile-tabs .mobile-tab").forEach((mobileTabButton) => {
    mobileTabButton.addEventListener("click", () => {
      const filter = mobileTabButton.dataset.filter;
      document.querySelector("#mobile-view").dataset.filter = filter;

      const activeTab = document.querySelector(".mobile-tabs .mobile-tab.active");
      if(activeTab){
        activeTab.classList.remove("active");
      }
      mobileTabButton.classList.add("active");
    })
  })
}
